import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Splash = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="93" viewBox="0 0 93 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.776 66.4867C40.3578 60.2381 52.8454 60.2381 59.4272 66.4867L62.5146 69.4176L62.4061 65.6611C62.1738 57.6528 71.7402 51.5395 82.0563 53.1043L86.8957 53.8387L83.6413 51.0144C76.7043 44.9933 78.872 35.6275 88.0957 31.776L92.4224 29.9693L87.5456 29.3981C77.1488 28.1818 70.905 19.9459 74.72 12.481L76.5094 8.97888L72.2912 10.9286C63.2998 15.0864 51.5658 11.8339 48.1875 4.24704L46.6026 0.68832L45.0176 4.24704C41.6394 11.833 29.9053 15.0854 20.9139 10.9286L16.6957 8.97888L18.4851 12.481C22.3002 19.9459 16.0563 28.1818 5.65953 29.3981L0.78273 29.9693L5.10945 31.776C14.3331 35.6275 16.5008 44.9923 9.56385 51.0144L6.30945 53.8387L11.1488 53.1043C21.465 51.5395 31.0304 57.6518 30.799 65.6611L30.6906 69.4176L33.7779 66.4867H33.776Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
